export const SELF_APPROVAL_ERROR_MSG =
  'Employees cannot approve their own requests. Please assign a different approver.';

export function isSelfApproval(currentEmployeeNumber, submitterEmployeeNumber) {
  if (!currentEmployeeNumber || !submitterEmployeeNumber) return false;
  return String(currentEmployeeNumber).trim() === String(submitterEmployeeNumber).trim();
}

export async function notifySelfApproval(api, { employeeNumber, employeeName, submissionId, benefitType }) {
  try {
    await api.Post('notification/self-approval', {
      employeeNumber,
      employeeName,
      submissionId,
      benefitType,
      message: `Approver matches employee ${employeeName || employeeNumber}. The approver needs to be reassigned.`,
    });
  } catch {
    // Notification failure should not block the self-approval guard.
  }
}
